'use strict';

var _ = require('lodash');
var UserActionTooltipFactory = function UserActionTooltipFactory(momentConstants) {
  var HIDE_DELAY = 10;
  function UserActionTooltipFactory() {}
  UserActionTooltipFactory.constructor = UserActionTooltipFactory;
  function getHtmlContent(cellData, wholeGridData) {
    var tooltipData = {
      actions: wholeGridData[cellData.row]['actions'],
      format: momentConstants.FORMATS.USER_ACTION_DATE_TIME
    };
    var tooltipContent = _.template(require('../templates/user-action-tooltip.html'));
    return tooltipContent(tooltipData);
  }
  UserActionTooltipFactory.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      if (cellData.value) {
        return {
          htmlContent: getHtmlContent(cellData, wholeGridData),
          hideDelay: HIDE_DELAY,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return UserActionTooltipFactory;
};
UserActionTooltipFactory.$inject = ['MomentConstants'];
module.exports = UserActionTooltipFactory;